import { totalAboveValueColorTrigger } from './model'

/** React Router's URL path */
export const PATH = '/project_profit_sheet'
export const PATH_OVERVIEW = `${PATH}/overview`

/** title on the layout header */
export const HEADER = 'Project Profit Sheet'

/** module's redux state name */
export const REDUCER_NAME = 'pps'

export const PROJECT_TYPE_DROPDOWN = [
  { label: 'Select Type', value: '' },
  { label: 'Fixed-Fee', value: 'FIXFEE' },
  { label: 'Time Material', value: 'TIME_MATERIAL' },
  { label: 'Support', value: 'SUPPORT' },
  { label: 'Internal', value: 'SPECIFIC' },
  { label: 'Common', value: 'COMMON' },
  { label: 'IAM Product', value: 'IAM_PRODUCT' },
  { label: 'Cloud', value: 'CLOUD' },
]

export const PROJECT_STATUS_DROPDOWN = [
  { label: 'Select Status', value: '' },
  { label: 'Implementing', value: 'IMPLEMENTING' },
  { label: 'Done', value: 'DONE' },
]

export const PROJECT_TYPE = {
  FIXFEE: 'Fixed-Fee',
  TIME_MATERIAL: 'Time Material',
  SUPPORT: 'Support',
  SPECIFIC: 'Internal',
  COMMON: 'Common',
  IAM_PRODUCT: 'IAM Product',
  CLOUD: 'Cloud',
}

export const SUBMIT_STATUS = {
  UNSUBMIT: 'Unsubmitted',
  SUBMIT: 'Submit',
}

export const PROJECT_STATUS = {
  IMPLEMENTING: 'Implementing',
  DONE: 'Done',
}

// export const COST_TYPE_MAPPING = {
//   '-': 'Cost Type',
//   vendor: 'Other Service',
//   hardware: 'Hardware',
//   hardware_ma: 'Hardware/MA',
//   license: 'License',
//   license_ma: 'License/MA',
//   license_subscription: 'Subscription',
//   other: 'Other Cost',
// }

export const COST_TYPE_MAPPING = {
  '-': 'Cost Type',
  SERVICE: 'Service',
  LICENSE: 'License',
  LICENSE_MA: 'License MA',
  SUBSCRIPTION: 'Subscription',
  HARDWARE_MA: 'Hardware MA',
  HARDWARE: 'Hardware',
  OTHER_SERVICE: 'Other Service',
  OTHER_COST: 'Other Cost',
  CR: 'CR',
}

export const MD = n => `${n} MDs`
export const WMD = n => `${n} WMDs`

export const ABOVE_INITIAL_PLAN = totalAboveValueColorTrigger(['#f0ad4e', '#ffdba8'])
export const ABOVE_CURRENT_PRICE = totalAboveValueColorTrigger(['#d44b49', '#ecadad'])



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/constants.js